import React,  {useState} from 'react'
import ChatBG from './img/chat-vec.png';
import ContactForm from './Components/ContactForm';

function Chat() {

    return (
        <div className="chat">
                <div className="chat-bg"/>
                <div className="chat-bg-white"/>
                <img src={ChatBG} />           
                <div className="chat-content">
                    <ContactForm />
                </div>
        </div>
    )
}

export default Chat
